export default __webpack_public_path__ + "static/media/logo-white-1.e094a05e.svg";